/* eslint-disable react/destructuring-assignment */
import React from "react";
import FormattedDate from "pages/_components/FormattedDate";
import Button from "pages/_components/Button";
import FormmatedText from "./_components/FormmatedText";
import { customTextPropType, defaultCustomTextPropType } from "./customTextPropType";

const CustomText = (props) => {
    const customClass = `custom-text ${props.className}`;

    const finalText = props.text === 0 ? "0" : props.text;

    return !!finalText || props.keepSpaceIfNoText ? (
        <div style={{ display: "flex" }}>
            <span className={`${customClass}`}>
                {!!finalText && props.textType !== "DATE" && (
                    <FormmatedText text={finalText} textType={props.textType} toLower={props.toLower} />
                )}
                {!!finalText && props.textType === "DATE" && (
                    <FormattedDate date={finalText} dateFormat={props.dateFormat} />
                )}
            </span>
            {props.showTooltip && (
                <Button
                    className="icon-button"
                    bsStyle="link"
                    image="images/figma/icon/info.svg"
                    block={false}
                    style={{ padding: "0 0 0 6px" }}
                    onClick={props.onTooltipClick}
                />
            )}
        </div>
    ) : null;
};

CustomText.propTypes = customTextPropType;
CustomText.defaultProps = defaultCustomTextPropType;

export default CustomText;
